// src/api/enrolledPrograms.js
// Shared utility for fetching user's enrolled programs

import api from './api';
import { getProgramMembers } from './programs';

const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

/**
 * Fetch all programs from user's clubs and check enrollment status
 * Used by both upcomingEvents and myAssignments
 */
export const getUserEnrolledPrograms = async (userClubs, userProfile) => {
  if (!userClubs || !userProfile) {
    return [];
  }

  const enrolledPrograms = [];

  // Get all clubs the user is a member of
  for (const membership of userClubs) {
    const clubId = membership.club?._id || membership.club;
    
    if (!clubId) {
      continue;
    }

    try {
      // Fetch all programs for this club
      const response = await fetch(`${backendUrl}/api/programs/club/${clubId}`);
      
      if (!response.ok) {
        continue;
      }

      const programs = await response.json();
      
      if (!Array.isArray(programs)) {
        continue;
      }

      // Check enrollment status for each program
      for (const program of programs) {
        try {
          // Get all members of this program
          const members = await getProgramMembers(program._id);
          
          // Check if current user is enrolled OR has club management access
          const userMembership = Array.isArray(members) 
            ? members.find(m => {
                const memberId = m.userId || m.user?._id;
                return memberId === userProfile._id;
              })
            : null;
          
          // Check if user has club management role (Creator, Owner, Manager)
          const hasClubAccess = ['Creator', 'Owner', 'Manager', 'creator', 'owner', 'manager'].includes(membership.role);

          const isEnrolledInProgram = userMembership && userMembership.status === 'Enrolled';
          const hasAccess = isEnrolledInProgram || hasClubAccess;

          if (hasAccess) {
            enrolledPrograms.push({
              ...program,
              clubId,
              clubName: membership.club?.name,
              userMembershipStatus: isEnrolledInProgram ? userMembership.status : 'Club Access',
              userRole: isEnrolledInProgram ? userMembership.role : membership.role
            });
          }
        } catch (err) {
          // Continue to next program on error
        }
      }
    } catch (err) {
      // Continue to next club on error
    }
  }

  return enrolledPrograms;
};

/**
 * Fetch enrolled programs using authenticated API (for assignments)
 */
export const getUserEnrolledProgramsAuth = async (userClubs, userProfile) => {
  if (!userClubs || !userProfile) {
    return [];
  }

  const enrolledPrograms = [];

  for (const membership of userClubs) {
    const clubId = membership.club?._id || membership.club;
    
    if (!clubId) {
      continue;
    }

    try {
      const programs = await api.get(`/api/programs/club/${clubId}`);
      
      if (!Array.isArray(programs)) {
        continue;
      }

      for (const program of programs) {
        try {
          const members = await getProgramMembers(program._id);
          
          const userMembership = Array.isArray(members) 
            ? members.find(m => {
                const memberId = m.userId || m.user?._id;
                return memberId === userProfile._id;
              })
            : null;
          
          const hasClubAccess = ['Creator', 'Owner', 'Manager', 'creator', 'owner', 'manager'].includes(membership.role);
          const isEnrolledInProgram = userMembership && userMembership.status === 'Enrolled';
          const hasAccess = isEnrolledInProgram || hasClubAccess;

          if (hasAccess) {
            enrolledPrograms.push({
              ...program,
              clubId,
              clubName: membership.club?.name,
              userMembershipStatus: isEnrolledInProgram ? userMembership.status : 'Club Access',
              userRole: isEnrolledInProgram ? userMembership.role : membership.role
            });
          }
        } catch (err) {
          // Continue on error
        }
      }
    } catch (err) {
      // Continue on error
    }
  }

  return enrolledPrograms;
};













